// src/api/stickerCart.js
//
// КОРЗИНА СТИКЕРОВ (пп.87–89, сессия 2026-10-29).
//
// ⚠️ Этот файл — ДЛЯ СТИКЕРОВ. Товарная корзина живёт в `api/cart.js`
//    (`/cart`), и смешивать их нельзя: `/cart` требует `product_id`,
//    а стикер — не товар (разбор — в `backend/controllers/
//    stickerCartController.js`).
//
// 🔑 ЗАГОЛОВОК `x-session-id` ПОДСТАВЛЯЕТСЯ АВТОМАТИЧЕСКИ И ВСЕГДА —
//    это делает перехватчик в `client.js` (без него гостевая корзина
//    не работала вовсе, сессия 7). Здесь повторно ничего не отправляем.
import client from './client.js';

export const stickerCartAPI = {
  get: () => client.get('/sticker-cart'),

  /**
   * Положить стикер.
   * @param {object} data
   *   { sticker_image_id, size_mm, quantity, rights_confirmed } — из каталога;
   *   { size_mm, quantity, rights_confirmed, design_status:'pending' } — «пришлю картинку».
   * ⚠️ Цену НЕ передаём: её считает сервер. Передать её значило бы
   *    предложить клиенту обсудить сумму.
   */
  add: (data) => client.post('/sticker-cart', data),
  update: (id, data) => client.put(`/sticker-cart/${id}`, data),
  remove: (id) => client.delete(`/sticker-cart/${id}`),

  /**
   * Приложить свою картинку к строке корзины.
   * @param {string} id
   * @param {File} file
   * @param {(pct:number)=>void} [onProgress]
   */
  uploadImage: (id, file, onProgress) => {
    const fd = new FormData();
    fd.append('file', file);
    return client.post(`/sticker-cart/${id}/image`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
  },

  /** Оформить заказ из корзины стикеров. Цена и доставка — серверные. */
  createOrder: (data) => client.post('/sticker-cart/order', data),
};

/**
 * Адрес для показа СВОЕЙ картинки. Не путь на диске, а маршрут API:
 * файл отдаётся только владельцу строки корзины (проверка на сервере).
 * Возвращаем URL для `<img>` — с ним нельзя поставить заголовок, поэтому
 * идентификатор сессии передаётся query-параметром, как в `getCart`.
 */
export const customImageUrl = (itemId, sessionId) =>
  `${client.defaults.baseURL}/sticker-cart/${itemId}/image?session_id=${encodeURIComponent(sessionId || '')}`;
